import React, { useEffect, useState } from 'react';
import { Password } from '../constant';
import { useNavigate } from 'react-router-dom';
import API from '../services/API';
import { toastify } from '../components/toastify';

const LoginPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);

  // ✅ Check token on mount
  const getToken = async () => {
    try {
      const jwt_token = localStorage.getItem('token');
      if (!jwt_token) return;

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'token': jwt_token
      };

      const response = await API.get('/ppdPortal/checkToken', { headers });
      if (response.data.response_code === 1000) {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error("Token check failed:", error);
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  // ✅ Handle login
  const handleSubmit = async () => {
    if (!state.email || !state.password) {
      toastify.error("Email and password are required", { autoClose: 5000 });
      return;
    }

    try {
      setLoading(true);
      const response = await API.post('/ppdPortal/login', {
        email: state.email,
        password: state.password
      });

      const res = response.data;
      if (res.response_code === 1000) {
        const { token, role, daerah } = res.data;

        // Store only required fields
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
        localStorage.setItem('daerah', daerah);

        navigate('/dashboard');
      } else {
        toastify.error(res.message || "Login failed", { autoClose: 5000 });
      }
    } catch (error) {
      console.error("Login error:", error);
      toastify.error("Something went wrong. Please try again.", { autoClose: 5000 });
    } finally {
      setLoading(false);
    }
  };

  const onChange = (field, event) => {
    setState(prev => ({ ...prev, [field]: event.target.value }));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <div className="col-md-12 bg-white">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <div className="text-center">
                    <img src="https://imgur.com/kEzgWVd.png" alt="Logo" height={150} />
                    <h2>Jaringan Keselamatan Anak Anda</h2>
                  </div>
                  <div className="card mt-4">
                    <div className="card-body">
                      <div className="text-center">
                        <h4>Login PPD Portal</h4>
                        <h6>Enter your Email and Password</h6>
                      </div>
                      <form className="theme-form" onSubmit={e => e.preventDefault()}>
                        <div className="form-group">
                          <label className="col-form-label pt-0">Email</label>
                          <input
                            className="form-control"
                            type="email"
                            value={state.email}
                            onChange={e => onChange('email', e)}
                          />
                        </div>
                        <div className="form-group">
                          <label className="col-form-label">{Password}</label>
                          <input
                            className="form-control"
                            type="password"
                            value={state.password}
                            onChange={e => onChange('password', e)}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        <div className="form-group form-row mt-3 mb-0 d-grid">
                          <button
                            className="btn"
                            style={{ backgroundColor: "#E94057", color: 'white', fontWeight: 'bold' }}
                            type="button"
                            onClick={handleSubmit}
                            disabled={loading}
                          >
                            {loading ? "Logging in..." : "LOGIN"}
                          </button>
                        </div>
                        <div className="text-center mt-3">
                          <a
                            href="/forgot-password"
                            style={{ color: "#E94057", fontWeight: "bold", fontSize: "14px" }}
                          >
                            Forgot Password?
                          </a>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
